import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

//PAGES
import { LoginPage } from '../login/login';
import { EntregasPage } from '../entregas/entregas';

//PROVIDERS
import { Tools, User, Api } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-forgot',
  templateUrl: 'forgot.html',
})
export class ForgotPage {
  username:string='';
  base:string='';
  check:boolean=false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private tools: Tools,
    private api: Api
  ) {}

  ionViewDidLoad(){
    this.base = this.navParams.get('item');
    console.log(this.base)
  }

  enviar(){
    if(this.check){return}
    this.check=true;

    var loading = this.tools.showLoading('Carregando...');
    loading.present();

    if(this.username==''){
      this.tools.showAlert('toast','Preencha com seu e-mail ou usuário.');
      return
    }

    let obj = {
    	"app_key":"d0f23d0f23sd0f23",
    	"app_secret":"s2d1f56as1dfg65as",
    	"base":this.base+'',
      "username":this.username
    }

    this.api.sendPost('http://barbosa.ibrs.com.br:4032/ws/api/tracking/enviaremail',obj,{},(result)=>{
      console.log(result);
      loading.dismiss();
      this.check=false;

      if(result.status){
        alert('Você receberá um e-mail com a nova senha!');
        var pag = this.base=='cadMotoristas'?'MOT':'USER'
        this.navCtrl.setRoot(LoginPage,{item:pag});
        return;
      }
      this.tools.showAlert('toast',result.msg);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/forgot/forgot.ts